import { el } from "@dhx/ts-common/dom";
import locale from "../locales/en";
import { IStat } from "../types";

function charsExlSpace(text: string): number {
	return text.replace(/[\n ]/g, "").length;
}

function chars(text: string): number {
	return text.replace(/[\n]/g, "").length;
}

function words(text: string): number {
	return text.split(/[\n !.?,:;]+/g).filter(word => word.length > 0).length;
}

const defaultStats = {
	words,
	chars,
	charsExlSpace,
};

export function getStats(text: string, customStats?: IStat[]) {
	if (customStats) {
		const stats: { [key: string]: number } = {};

		for (const { cb, name } of customStats) {
			if (typeof cb === "function") {
				stats[name] = cb(text);
			} else if (!cb && name in defaultStats) {
				stats[name] = defaultStats[name](text);
			} else if (typeof cb === "string" && cb in defaultStats) {
				stats[name] = defaultStats[cb](text);
			}
		}
		return stats;
	}
	return {
		chars: defaultStats.chars(text),
		words: defaultStats.words(text),
		charsExlSpace: defaultStats.charsExlSpace(text),
	};
}

function getDefaultRenderStat() {
	return [{ name: "chars" }, { name: "charsExlSpace" }, { name: "words" }];
}

export function statsRenderer(
	stats: { [key: string]: number },
	statSequence: IStat[] = getDefaultRenderStat()
): () => any {
	return () =>
		el(
			"ul.dhx_richtext-stat",
			statSequence.map(stat =>
				el("li.dhx_richtext-stat__item", [
					el("span.dhx_richtext-stat__name", locale[stat.name] || stat.name),
					el("span.dhx_richtext-stat__value", stats[stat.name]),
				])
			)
		);
}
